import styled from 'styled-components';

export const ErrorMessage = styled.span`
  font-weight: 700;
  font-size: 1.5rem;
  color: #fff;
  padding: 10px 20px 15px 20px;
  background-color: firebrick;
`;
